import { render } from "./Subscription.vue?vue&type=template&id=23c4f7d6&scoped=true"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"

import "./Subscription.vue?vue&type=style&index=0&id=23c4f7d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c4f7d6"]])

export default __exports__